import { NO_DURATION_ANIMATIONS } from 'js/config/consts';

export const animationTypeHasNoDuration = (animationType?: string) => {
  if (!animationType) return false;

  return NO_DURATION_ANIMATIONS.includes(animationType);
};
